import axios from '@client/lib/axios'

export const fetchAll = () => {
  return axios({
    method: 'get',
    url: '/api/2/opening_times'
  })
}
